import { z } from 'zod'
import ApiService from '../api.service'

export interface Treinamento {
    id: number
    clienteId: number
    data: string
    quemRecebeu: string
    usuarioId: number
    observacao: string | null
    cobranca: boolean
    createdAt: string
    updatedAt: string
    Cliente: { nomeFantasia: string }
    Usuario: { id: number; email: string }
}

/** Payload enviado à API — o form usa `Tecnico`, convertido em `usuarioId`. */
export interface TreinamentoPayload {
    clienteId?: number
    data?: string
    quemRecebeu?: string
    usuarioId?: number
    observacao?: string | null
    cobranca?: boolean
}

export const treinamentoSchema = z.object({
    data: z.string().min(1, 'Informe a data do treinamento'),
    quemRecebeu: z
        .string()
        .trim()
        .min(1, 'Informe quem recebeu o treinamento')
        .max(50, 'Máximo de 50 caracteres'),
    Tecnico: z.object(
        {
            id: z.number(),
            email: z.string(),
            nome: z.string(),
        },
        { invalid_type_error: 'Selecione o técnico responsável' },
    ),
    observacao: z
        .string()
        .trim()
        .max(250, 'Máximo de 250 caracteres')
        .optional(),
    cobranca: z.boolean().default(false),
})

export type TreinamentoInput = z.infer<typeof treinamentoSchema>

export const treinamentos = new ApiService<TreinamentoPayload, Treinamento>(
    'treinamentos',
)
